import React from 'react';
import { connect } from 'react-redux';
import { noteActions } from '_actions';
import { bindActionCreators } from 'redux';
import { ObjectiveFlag, AddButton } from '_components';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { PatientCareCenterNoteObjectiveAsteriskRow } from 'PatientCareCenter/Note/Objective/Asterisks';
import styles from './Common.module.css'

class PatientCareCenterNoteObjectiveAsterisks extends React.Component {

    addAsterisk() {
        if (this.props.noteType === 1) {
            this.props.addChildRow(this.props.noteId, 'PTOBJECTIVEASTERISKS', 'OA', 'OAEVNO', this.props.pk);
        } else {
            this.props.addChildRow(this.props.noteId, 'PTOBJECTIVEASTERISKS', 'OA', 'OANTNO', this.props.pk);
        }
        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }
    }

    render() {
        // only render if note type is DN or PN
        let validNoteTypes = [2, 3, 5];

        if (validNoteTypes.includes(this.props.noteType)) {
            return (

                <PatientCareCenterNoteSection id='obj_asterisks' name='Asterisk Signs' level={1}>

                    <div className={styles.row}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.panels.length > 0} flagText='Asterisk Signs' />
                        <div className={styles.add_button} >
                            <AddButton title='Add Asterisk Sign...' size='extra-small' onClick={() => this.addAsterisk()} />
                        </div>
                        {this.props.panels.length === 0 &&
                            <div className={styles.tip}>Click to add entry</div>
                        }
                        {this.props.panels.length > 0 &&
                            <span>
                                <div className={styles.column_header}>Asterisk Sign</div>
                                <div className={styles.column_header}>Pre-intervention</div>
                                <div className={styles.column_header}>Post-intervention</div>
                            </span>
                        }
                    </div>
                    {Object.keys(this.props.panels)
                        .map(key => {
                            const result = this.props.panels[key];
                            return (
                                <PatientCareCenterNoteObjectiveAsteriskRow key={result.OANO} id={result.OANO} />
                            )
                        })
                    }

                </PatientCareCenterNoteSection>

            );
        } else {
            return (
                <span />
            )
        }
    }

}

function mapDispatchToProps(dispatch) {
    return {
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        addChildRow: bindActionCreators(noteActions.addChildRow, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let panels = Object.keys(state.entities.notes.PTOBJECTIVEASTERISKS)
        .filter(key => {
            return (state.entities.notes.PTOBJECTIVEASTERISKS[key].OAEVNO === pk && noteType === 1) ||
                (state.entities.notes.PTOBJECTIVEASTERISKS[key].OANTNO === pk && noteType !== 1)
        })
        .sort((a, b) => state.entities.notes.PTOBJECTIVEASTERISKS[a].OANO - state.entities.notes.PTOBJECTIVEASTERISKS[b].OANO)
        .map(key => state.entities.notes.PTOBJECTIVEASTERISKS[key]);
    let objUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTOBJECTIVEUPDATED : true;

    return {
        noteId,
        noteType,
        pk,
        panels,
        objUpdated
    };
}

const connectedPatientCareCenterNoteObjectiveAsterisks = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveAsterisks);
export { connectedPatientCareCenterNoteObjectiveAsterisks as PatientCareCenterNoteObjectiveAsterisks };

